import type { ReactNode } from 'react';
import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';

export default function Layout({ children }: { children: ReactNode }) {
  return (
    <>
      <Header />
      <main>{children}</main>
      <Footer />
    </>
  );
}